import React, {useContext, useEffect, useState} from 'react';
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import HotelsListItem from "../components/Hotel-list-item/Hotels-list-item";
import {LangContext} from "../App";
import {axios} from "../axios";
import hotelImage from '../assets/images/test/hotelImage.jpg';
import Seo from "../components/Seo/Seo";

const content = {
    en: {
        heroTitle: "Hotels in Armenia",
        heroText: "Browse hotels and choose a place to stay during your trip to Armenia.",
    },
    de: {
        heroTitle: "Hotels in Armenien",
        heroText: "Durchsuchen Sie die Hotels und wählen Sie eine Unterkunft für Ihre Reise nach Armenien.",
    },
};

const HotelsPage = () => {
    const [data,setData] = useState([])
    const [regions,setRegions] = useState([])
    const [region,setRegion] = useState('')
    const lang = useContext(LangContext)
    const t = content[lang] || content.en
    useEffect(()=>{
        axios.get(`${lang}/hotel?region=${region}`)
            .then(res => setData(res.data.tours || []))
            .catch(err => {
                console.error('Error fetching hotels:', err);
                setData([]);
            });
        axios.get(`${lang}/region`)
            .then(res => setRegions(res.data || []))
            .catch(err => {
                console.error('Error fetching regions:', err);
                setRegions([]);
            });
    },[lang,region])
    return (
        <div className='hotels-page'>
            <Seo pageKey="hotels" />
            <PageIntroSection title={t.heroTitle}
                              image={hotelImage}
                              text={t.heroText}
            />
            <div className="center-wrapper flex-column mt-4">
                <div className="d-flex">
                    <button
                        onClick={()=> setRegion('')}
                        className={`btn btn-custom ${region === '' && 'active'}`}
                    >All</button>
                    {
                        regions.map((e) => {
                            return (
                                <button
                                    key={e.id}
                                    onClick={()=> setRegion(e.id)}
                                    className={`btn btn-custom ${region === e.id && 'active'}`}
                                >{e.title_en}</button>
                            )
                        })
                    }
                </div>
            </div>
            <div className="center-wrapper">
                <div className="hotels-list">
                    {data.map((e,i) => <HotelsListItem path='hotels-page' key={e.id} tour={e} i={i}/>)}
                </div>
            </div>
        </div>
    );
};

export default HotelsPage;